import { render, staticRenderFns } from "./ShareCreditDialog.vue?vue&type=template&id=210e548e&scoped=true"
import script from "./ShareCreditDialog.vue?vue&type=script&lang=ts"
export * from "./ShareCreditDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "210e548e",
  null
  
)

export default component.exports